import React from 'react'
import './styles.scss'
import { SquareGrid } from 'components/SquareGrid'

export const DatacenterPower = ({
  name,
  power,
  gridprops,
  direction = 'lr',
  isMobile = false
}: {
  name: string | string[]
  power: number
  gridprops: GridProps
  direction?: 'rl' | 'lr'
  isMobile: boolean
}) => {
  let rl = direction === 'rl' ? true : false
  return (
    <g className='DatacenterPower'>
      <DataCenterLabel
        x={0}
        y={-30}
        name={name}
        power={power + ' MW'}
        textAnchor={rl ? 'end' : 'start'}
        lineHeight={isMobile ? 18 : 20}
      />
      <MovedGroup x={rl ? -gridprops.cellsize : 0} y={0}>
        <SquareGrid
          {...{
            ...gridprops,
            cellcount: Math.round(power),
            direction: direction
          }}
        />
      </MovedGroup>
    </g>
  )
}

const DataCenterLabel = ({
  x,
  y,
  name,
  power,
  textAnchor = 'start',
  lineHeight = 25
}: {
  x: number
  y: number
  lineHeight: number
  name: string | string[]
  power: string
  textAnchor?: 'start' | 'middle' | 'end'
}) => (
  <g transform={`translate(${x},${y})`}>
    {Array.isArray(name) ? (
      <text
        className='datacenter name'
        textAnchor={textAnchor}
        y={-lineHeight * name.length}
      >
        {name.map((m, i) => (
          <tspan x={0} dy={lineHeight}>
            {m}
          </tspan>
        ))}{' '}
      </text>
    ) : (
      <text className='datacenter name' textAnchor={textAnchor}>
        {name}
      </text>
    )}

    <text y={lineHeight} className='datacenter power' textAnchor={textAnchor}>
      {power}
    </text>
  </g>
)
const MovedGroup = ({
  x,
  y,
  children
}: {
  x: number
  y: number
  children?: JSX.Element | string | undefined
}) => <g transform={`translate(${x},${y})`}>{children && children}</g>
